import { AppBar, Avatar, Box, Button, Container, IconButton, List, ListItem, ListItemButton, ListItemText, Menu, MenuItem, Toolbar, Tooltip, Typography } from '@mui/material';
import AdbIcon from '@mui/icons-material/Adb';
import MenuIcon from '@mui/icons-material/Menu';
import React from 'react'
//import fondo1 from './Inicio/1626.jpeg';
import { useAppContext } from './AppProvider';


const paginasFuncionario = ['Inicio', 'Solicitudes', 'Notificaciones/Actividades Pendientes', 'Consultas', 'Calificaciones'];
const settingsFuncionarios = ['Inicio', 'Solicitudes', 'Notificaciones/Actividades Pendientes', 'Consultas', 'Calificaciones', 'Cambiar Password', 'Logout'];

//const paginasFuncionario = ['Inicio', 'Solicitudes', 'Consultas'];
//const settingsFuncionarios = ['Inicio', 'Solicitudes', 'Consultas', 'Cambiar Password', 'Logout'];

const paginasPersonal = ['Inicio', 'Mantenimiento de archivos', 'Consultas', 'Control Asistencia', 'Informes', 'Actividades Pendientes', 'Gestión de Usuarios'];
const settingPersonal = ['Inicio', 'Mantenimiento de archivos', 'Consultas', 'Control Asistencia', 'Informes', 'Actividades Pendientes', 'Gestión de Usuarios', 'Cambiar Password', 'Logout'];

const paginasAdmin = ['Inicio', 'Mantenimiento de archivos', 'Consultas', 'Control Asistencia', 'Informes', 'gestion de usuarios', 'Pruebas'];
const settingAdmin = ['Inicio', 'Mantenimiento de archivos', 'Consultas', 'Control Asistencia', 'Informes', 'gestion de usuarios', 'Pruebas', 'Logout'];

const paginasFinal = ['Inicio', 'Informes', 'Consultas', 'Sorteos', 'Concursos'];
const settingFinal = ['Inicio', 'Informes', 'consultas', 'Sorteos', 'Concursos', 'Logout'];

const paginasJefes = ['Inicio', 'Solicitudes Pendientes', 'Actividades Pendientes', 'Calificaciones', 'Consultas'];
const settingJefes = ['Inicio', 'Solicitudes Pendientes', 'Actividades Pendientes', 'Calificaciones', 'Consultas', 'Cambiar Password', 'Logout'];

//const paginasJefes = ['Inicio', 'Solicitudes Pendientes', 'Actividades Pendientes'];
//const settingJefes = ['Inicio', 'Solicitudes Pendientes', 'Actividades Pendientes', 'Cambiar Password', 'Logout'];

const paginasVacacional = ['Inicio', 'Solicitudes Pendientes', 'Consultas'];
const settingVacacional = ['Inicio', 'Solicitudes Pendientes', 'Consultas', 'Logout'];



function Barra (props) {
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);

    //Seteo los link de los funcionarios
    const [linkFuncionarioPersonal, setLinkFuncionarioPersonal] = React.useState(['./Inicio', './MantArchivo', './Consultas', './ControlAsistencia', './Informes', './Actividades-pendientes', './GestionUsuario', './GestionUsuarios-cambioPassword','/personal-app/login']);
    const [linkAdmin, setLinkAdmin] = React.useState(['./Inicio', './MantArchivo', './Consultas', './ControlAsistencia', './Informes', './gestion-usuarios', './Pruebas', '/personal-app/login']);
    //const [linkJefes, setLinkJefes] = React.useState(['./Inicio', './Informes', './Actividades-pendientes', './Calificaciones', '/personal-app/login']);
    const [linkJefes, setLinkJefes] = React.useState(['./Inicio', './Informes', './Actividades-pendientes', './Calificaciones', './Consultas', './GestionUsuarios-cambioPassword', '/personal-app/login']);
    //const [linkFuncionarios, setLinkFuncionarios] = React.useState(['./Inicio', './Consultas', './Informes', './Calificaciones', '/personal-app/login']);
    const [linkFuncionarios, setLinkFuncionarios] = React.useState(['./Inicio', './Informes', './Notificarse', './Consultas', './Calificaciones', './GestionUsuarios-cambioPassword', '/personal-app/login']);
    const [linkJefeFinal, setlinkJefeFinal] = React.useState(['./Inicio', './Informes', './Consultas', './Sorteos', './Concursos', '/personal-app/login']);
    const [linkVacacional, setlinkVacacional] = React.useState(['./Inicio', './Informes', './Consultas', '/personal-app/login']);
    const [pruebita, setPruebita] = React.useState([sessionStorage.fotoPerfil]);
    //const {login} = useAppContext();
    //const {dispatch} = useAppContext();

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    return (
        <>
            <AppBar position='static' style={{background:'#D53A25'}}>
                <Container maxWidth='xl'>
                    <Toolbar disableGutters>
                        {/*login
                        ?
                            'Con login'
                        :
                            'Sin login'
                        */}
                        {sessionStorage.login
                        ?
                            <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }} >
                                {sessionStorage.tipoUsuario === '2'
                                ?
                                    paginasFuncionario.map((page, index) => (
                                        <ListItem key={page} disablePadding>
                                            <ListItemButton href={linkFuncionarios[index]}>
                                                <ListItemText primary={page}/>
                                            </ListItemButton>
                                        </ListItem>
                                    ))
                                :
                                    sessionStorage.tipoUsuario === '4'
                                    ?
                                        paginasPersonal.map((page, index) => (
                                            <ListItem key={page} disablePadding>
                                                <ListItemButton sx={{width: '1px'}}  href={linkFuncionarioPersonal[index]}>
                                                    <ListItemText primary={page}/>
                                                </ListItemButton>
                                            </ListItem>
                                        ))
                                    :
                                        sessionStorage.tipoUsuario === '1'
                                        ?
                                            paginasAdmin.map((page, index) => (
                                                <ListItem key={page} disablePadding>
                                                    <ListItemButton sx={{width: '1px'}}  href={linkAdmin[index]}>
                                                        <ListItemText primary={page}/>
                                                    </ListItemButton>
                                                </ListItem>
                                            ))
                                        :
                                            sessionStorage.tipoUsuario === '5'
                                            ?
                                                paginasFinal.map((page, index) => (
                                                    <ListItem key={index} disablePadding>
                                                        <ListItemButton sx={{width: '1px'}}  href={linkJefeFinal[index]}>
                                                            <ListItemText primary={page}/>
                                                        </ListItemButton>
                                                    </ListItem>
                                                ))
                                            :
                                                sessionStorage.tipoUsuario === '3'
                                                ?
                                                    paginasJefes.map((page, index) => (
                                                        <ListItem key={index} disablePadding>
                                                            <ListItemButton sx={{width: '1px'}}  href={linkJefes[index]}>
                                                                <ListItemText primary={page}/>
                                                            </ListItemButton>
                                                        </ListItem>
                                                    ))
                                                :
                                                    sessionStorage.tipoUsuario === '6'
                                                    ?
                                                        paginasVacacional.map((page, index) => (
                                                            <ListItem key={index} disablePadding>
                                                                <ListItemButton sx={{width: '1px'}}  href={linkVacacional[index]}>
                                                                    <ListItemText primary={page}/>
                                                                </ListItemButton>
                                                            </ListItem>
                                                        ))
                                                    :
                                                        null
                                }
                            </Box>
                        :
                            null
                        }
                        {sessionStorage.login
                        ?
                            <Box sx={{ flexGrow: 0 }}>
                                <Tooltip title="Opciones">
                                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                                    <Avatar src={sessionStorage.fotoPerfil} alt='Logo Chlaep'/>
                                    {/*<Avatar src="img/perfil.jpg" alt='Logo Chlaep'/>*/}
                                </IconButton>
                                </Tooltip>
                                <Menu sx={{ mt: '45px' }} id="menu-appbar" anchorEl={anchorElUser} anchorOrigin={{ vertical: 'top', horizontal: 'right', }} keepMounted transformOrigin={{ vertical: 'top', horizontal: 'right', }} open={Boolean(anchorElUser)} onClose={handleCloseUserMenu} >
                                    <List>
                                        {sessionStorage.tipoUsuario === '2'
                                        ?
                                            settingsFuncionarios.map((settingsFuncionarios, index) => (
                                                <ListItem key={settingsFuncionarios} disablePadding>
                                                    <ListItemButton href={linkFuncionarios[index]}>
                                                        <ListItemText primary={settingsFuncionarios}/>
                                                    </ListItemButton>
                                                </ListItem>
                                            ))
                                        :
                                            sessionStorage.tipoUsuario === '4'
                                            ?
                                                settingPersonal.map((settingPersonal, index) => (
                                                    <ListItem key={settingPersonal} disablePadding>
                                                        <ListItemButton href={linkFuncionarioPersonal[index]}>
                                                            <ListItemText primary={settingPersonal}/>
                                                        </ListItemButton>
                                                    </ListItem>
                                                ))
                                            :
                                                sessionStorage.tipoUsuario === '1'
                                                ?
                                                    settingAdmin.map((settingAdmin, index) => (
                                                        <ListItem key={settingAdmin} disablePadding>
                                                            <ListItemButton href={linkAdmin[index]}>
                                                                <ListItemText primary={settingAdmin}/>
                                                            </ListItemButton>
                                                        </ListItem>
                                                    ))
                                                :
                                                    sessionStorage.tipoUsuario === '5'
                                                    ?
                                                        settingFinal.map((settingFinal, index) => (
                                                            <ListItem key={settingFinal} disablePadding>
                                                                <ListItemButton href={linkJefeFinal[index]}>
                                                                    <ListItemText primary={settingFinal}/>
                                                                </ListItemButton>
                                                            </ListItem>
                                                        ))
                                                    :
                                                        sessionStorage.tipoUsuario === '3'
                                                        ?
                                                            settingJefes.map((settingJefes, index) => (
                                                                <ListItem key={settingJefes} disablePadding>
                                                                    <ListItemButton href={linkJefes[index]}>
                                                                        <ListItemText primary={settingJefes}/>
                                                                    </ListItemButton>
                                                                </ListItem>
                                                            ))
                                                        :
                                                            sessionStorage.tipoUsuario === '6'
                                                            ?
                                                                settingVacacional.map((settingVacacional, index) => (
                                                                    <ListItem key={settingVacacional} disablePadding>
                                                                        <ListItemButton href={linkVacacional[index]}>
                                                                            <ListItemText primary={settingVacacional}/>
                                                                        </ListItemButton>
                                                                    </ListItem>
                                                                ))
                                                            :
                                                                null
                                        }
                                    </List>
                                </Menu>
                            </Box>
                        :
                            null
                        }
                    </Toolbar>
                </Container>
            </AppBar>
        </>
    )
}

export default Barra